import React from "react";
import { Box, Typography } from "@mui/material";
import FormButton from "../FormButton";

interface RepresentationStepProps {
  hasAttorney: string;
  onChange: (field: string, value: string) => void;
}

const RepresentationStep: React.FC<RepresentationStepProps> = ({
  hasAttorney,
  onChange,
}) => {
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 2 out of 5
      </Typography>

      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        2. Are you currently represented by a lawyer for the accident?{" "}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormButton
          isSelected={hasAttorney === "NO"}
          onClick={() => onChange("hasAttorney", "NO")}
        >
          No
        </FormButton>

        <FormButton
          isSelected={hasAttorney === "YES"}
          onClick={() => onChange("hasAttorney", "YES")}
        >
          Yes, I already have a lawyer/received compensation
        </FormButton>
      </Box>
    </>
  );
};

export default RepresentationStep;
